<template>
  <button class="combine-pay-btn" id="CPBtn" ref="CPBtn" type="button" :style="updateStyle">

    <icon-wallet class="icon-wallet" :color="color" />

    <span class="btn-txt" :style="{color: color}">合并支付</span>

  </button>
</template>

<script>
  import Hammer from "hammerjs";
  import IconWallet from "./Icon/IconWallet";

  // 限制绘制帧
  const reqAnimationFrame = (function () {
    return window[Hammer.prefixed(window, 'requestAnimationFrame')]
            || (cb => window.setTimeout(cb, 1000/60))
  })();

  const screen = document.querySelector('html');

  export default {
    name: "CombinePayBtn",
    components: {IconWallet},
    data() {
      return {
        color: '#394BE5',
        hammer: null,
        startTransX: 0,
        startTransY: 0,
        updateStyle: {
          transform: 'translate3d(0, 0, 0)',
        },
        ticking: false,
        btnSize: {},
      }
    },

    methods: {

      // 初始化 hammer 实例，增加 pan 系列事件。
      initHammer() {
        const BtnEl = this.$refs['CPBtn'];
        this.btnSize = {
          w: BtnEl.offsetWidth,
          h: BtnEl.offsetHeight,
          l: parseInt(getComputedStyle(BtnEl).left),
          b: parseInt(getComputedStyle(BtnEl).bottom),
        };

        // set hammer event
        this.hammer = new Hammer.Manager(BtnEl);
        this.hammer.add(new Hammer.Pan({ threshold: 15, pointers: 0 }));
        this.hammer.add(new Hammer.Tap({ event: 'tripletap', threshold: 10, taps: 3, interval: 200}));
        this.hammer.add(new Hammer.Tap({ event: 'singletap', threshold: 10, }));
        this.hammer.get('tripletap').recognizeWith('singletap');
        this.hammer.get('singletap').requireFailure('tripletap');
        this.hammer.on('panstart panmove panend', this.onPan);
        this.hammer.on('tripletap singletap', e => e.type==="singletap"?this.onSingleTap():this.onTripleTap())

      },

      /**
       * 轻点一下：跳转
       */
      onSingleTap() {
        // 到 '合并支付' 页面
        this.$router.push({ name: 'combinePay' });
      },

      /**
       * 点击三下： 重置位置
       */
      onTripleTap() {
        this.$set(this, 'startTransX', 0);
        this.$set(this, 'startTransY', 0);
        this.$set(this, 'updateStyle', {
          transform: `translate3d(0, 0, 0)`,
          transition: 'transform 300ms ease',
        });
      },

      /**
       * 拖拽事件
       * @param e
       */
      onPan (e) {
        let startTransX = this.startTransX + e.deltaX;
        let startTransY = this.startTransY + e.deltaY;

        if (!this.ticking) {
          // limit range of x
          // left
          if (startTransX + this.btnSize.l <= 20) startTransX = (-this.btnSize.l + 20);
          // right
          if (window.innerWidth - this.btnSize.l - startTransX - this.btnSize.w <= 20)
            startTransX = (window.innerWidth - this.btnSize.l - this.btnSize.w - 20);
          // limit range of y
          // top: screenH - btnBottom - btnHeight - transY
          if (window.innerHeight - this.btnSize.b - this.btnSize.h + startTransY <= 20) {
            startTransY = -(window.innerHeight - this.btnSize.b - this.btnSize.h - 20);
          }
          // bottom
          if (this.btnSize.b - startTransY <= 20)
            startTransY = this.btnSize.b - 20;

          reqAnimationFrame(() => {
            this.$set(this, 'updateStyle', {
              transform: `translate3d(${startTransX}px, ${startTransY}px, 0)`
            });
            this.ticking = false;
          });

          this.ticking = true;
        }

        if (e.type === 'panend') {
          this.$set(this, 'startTransX', startTransX);
          this.$set(this, 'startTransY', startTransY);
        }
      },
    },


    mounted() {
      this.initHammer();
    }
  }
</script>

<style scoped lang="scss">

  .combine-pay-btn {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    box-shadow: 0 2px 7px rgba(219, 223, 255, 1);
    position: fixed;
    bottom: 198px;
    right: 16px;
    z-index: 30;
    padding: 0;
    transform: translate3d(0, 0, 0);
    will-change: transform;

    .icon-wallet {
      width: 26px;
      height: 26px;
    }

    .btn-txt {
      font-size: 10px;
      display: block;
    }
  }

</style>